import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowDownFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M24.39 16.38a2 2 0 0 0-2.94 0L18 20V7a2 2 0 0 0-4 0v13l-3.45-3.62a2 2 0 0 0-2.94 0 2.16 2.16 0 0 0 0 3l6.86 7a2.2 2.2 0 0 0 3.06 0l6.86-7a2.16 2.16 0 0 0 0-3" /></svg>;
const ForwardRef = forwardRef(IconArrowDownFilledSVG);
ForwardRef.displayName = "IconArrowDownFilled";
export { ForwardRef as IconArrowDownFilled };